import {
  ORDER_TYPE,
  PAYMENT_ACTION_STATUS,
  PAYMENT_STATUS,
  SLIP_IN_PROGRESS_STATUS,
  SLIP_STATUS,
  TRANSACTION_STATUS,
} from '../constants'
import { isAfter } from 'date-fns'

const STATUS_COLOR = {
  [PAYMENT_STATUS.UNKNOWN]: 'grey',
  [PAYMENT_STATUS.OPEN]: 'blue',
  [PAYMENT_STATUS.CONFIRM]: 'orange',
  [PAYMENT_STATUS.IN_PROGRESS]: 'orange',
  [PAYMENT_STATUS.SUCCESS]: 'green',
  [PAYMENT_STATUS.CANCEL]: 'red',
  [PAYMENT_STATUS.REFUND]: 'purple',
  [PAYMENT_STATUS.FAILED]: 'grey',
  [SLIP_STATUS.IN_PROGRESS]: 'orange',
  [SLIP_STATUS.COMPLETE]: 'green',
  [SLIP_STATUS.REJECT]: 'red',
  [SLIP_STATUS.REFUND]: 'purple',
  [SLIP_IN_PROGRESS_STATUS.OUT_QUEUE]: 'red',
  [SLIP_IN_PROGRESS_STATUS.BAD_SLIP]: 'red',
  [SLIP_IN_PROGRESS_STATUS.NONE]: 'grey',
}

export const getTextColorByStatus = (status) => {
  return STATUS_COLOR[status] || 'black'
}

const ACTION_STATUS_COLOR = {
  [PAYMENT_ACTION_STATUS.IN_PROGRESS]: 'orange',
  [PAYMENT_ACTION_STATUS.BLOCKED]: 'grey',
}

export const getTextColorByActionStatus = (status) => {
  return ACTION_STATUS_COLOR[status] || 'black'
}

const STATUS_TEXT = {
  [PAYMENT_STATUS.OPEN]: 'รอแจ้งโอน',
  [PAYMENT_STATUS.CONFIRM]: 'แจ้งโอนแล้ว',
  [PAYMENT_STATUS.IN_PROGRESS]: 'กำลังประมวลผล',
  [PAYMENT_STATUS.SUCCESS]: 'สำเร็จ',
  [PAYMENT_STATUS.CANCEL]: 'ยกเลิก',
  [PAYMENT_STATUS.REFUND]: 'คืนเงิน',
  [PAYMENT_STATUS.FAILED]: 'ไม่สำเร็จ',
  [SLIP_IN_PROGRESS_STATUS.UNKNOWN]: 'ทั้งหมด',
  [SLIP_IN_PROGRESS_STATUS.NONE]: 'อยู่ในคิว',
  [SLIP_IN_PROGRESS_STATUS.BAD_SLIP]: 'สลิปเสีย',
  [SLIP_IN_PROGRESS_STATUS.OUT_QUEUE]: 'หลุดคิว',
}

export const getButtonTextByStatus = (status) => {
  return STATUS_TEXT[status] || status
}

const ACTION_STATUS_TEXT = {
  [PAYMENT_ACTION_STATUS.IN_PROGRESS]: 'ล็อค',
  [PAYMENT_ACTION_STATUS.BLOCKED]: 'มีปัญหา',
}

export const getButtonTextByActionStatus = (status) => {
  return ACTION_STATUS_TEXT[status] || status
}

const ORDER_TYPE_TEXT = {
  [ORDER_TYPE.LOTTERY]: 'ลอตเตอรี่',
  [ORDER_TYPE.LOTTERY_DELIVERY]: 'จัดส่ง',
  [ORDER_TYPE.LOTTERY_NO_FEE]: '80 บาท',
  [ORDER_TYPE.LOTTERY_SAFE]: 'ฝาก',
  [ORDER_TYPE.POINT]: 'นกแคช',
  [ORDER_TYPE.UNKNOWN]: 'ทั้งหมด',
  [ORDER_TYPE.WITHDRAW]: 'ถอนเงิน',
  [ORDER_TYPE.COUPON_ORDER]: 'คูปอง',
}

export const getButtonTextByOrderType = (orderType) => {
  return ORDER_TYPE_TEXT[orderType] || orderType
}

const ORDER_TYPE_COLOR = {
  [ORDER_TYPE.UNKNOWN]: 'lightgrey',
  [ORDER_TYPE.LOTTERY]: 'rgba(255,0,125,0.5)',
  [ORDER_TYPE.LOTTERY_DELIVERY]: 'rgba(255,0,125,0.5)',
  [ORDER_TYPE.LOTTERY_NO_FEE]: 'rgba(255,0,125,0.5)',
  [ORDER_TYPE.LOTTERY_SAFE]: 'rgba(255,0,125,0.5)',
  [ORDER_TYPE.POINT]: 'rgba(255,127,127,0.5)',
  [ORDER_TYPE.WITHDRAW]: 'rgba(255,127,127,0.5)',
  [ORDER_TYPE.COUPON_ORDER]: 'rgba(255,100,220,0.5)',
}

export const getBackgroundColorByOrderType = (orderType) => {
  return ORDER_TYPE_COLOR[orderType] || 'black'
}

const STATUS_BACKGROUND_COLOR = {
  [PAYMENT_STATUS.UNKNOWN]: 'lightgrey',
  [PAYMENT_STATUS.OPEN]: 'lightblue',
  [PAYMENT_STATUS.CONFIRM]: 'rgba(255,160,50,0.35)',
  [PAYMENT_STATUS.IN_PROGRESS]: 'rgba(255,160,50,0.35)',
  [PAYMENT_STATUS.SUCCESS]: 'rgba(0,128,0,0.35)',
  [PAYMENT_STATUS.CANCEL]: 'rgb(255,192,203,0.75)',
  [PAYMENT_STATUS.FAILED]: 'lightgrey',
  [PAYMENT_STATUS.REFUND]: 'rgba(128,0,128,0.30)',
  [SLIP_STATUS.COMPLETE]: 'rgba(0,128,0,0.35)',
}

export const getBackgroundColorByStatus = (status) => {
  return STATUS_BACKGROUND_COLOR[status] || 'white'
}

const ACTION_STATUS_BACKGROUND_COLOR = {
  [PAYMENT_ACTION_STATUS.IN_PROGRESS]: 'rgba(175,100,255,0.5)',
  [PAYMENT_ACTION_STATUS.BLOCKED]: 'lightgrey',
}

export const getBackgroundColorByActionStatus = (status) => {
  return ACTION_STATUS_BACKGROUND_COLOR[status] || 'white'
}

const TRANSACTION_STATUS_COLOR = {
  [TRANSACTION_STATUS.PAID]: 'rgba(0,128,0,0.35)',
  [TRANSACTION_STATUS.UNPAID]: 'rgb(255,192,203,0.75)',
  [TRANSACTION_STATUS.UNKNOWN]: 'lightgrey',
}

export const getBackgroundColorByTransactionStatus = (status) => {
  return TRANSACTION_STATUS_COLOR[status] || 'white'
}

export const canCancelPayment = (payment) => {
  return payment.status === PAYMENT_STATUS.OPEN || payment.status === PAYMENT_STATUS.CONFIRM
}

export const canWithdrawPayment = (payment) => {
  return payment.orderType === ORDER_TYPE.WITHDRAW && payment.status === PAYMENT_STATUS.CONFIRM
}

export const isJsonString = (str) => {
  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}

export const isDateValid = (dateStr) => {
  return !isNaN(new Date(dateStr)) && new Date(dateStr).getTime() > 0
}

export const isHoldItemExpiredDisplay = (payment) => {
  return (
    payment.status === PAYMENT_STATUS.CANCEL &&
    isDateValid(payment?.holdItemExpiredAt) &&
    isAfter(new Date(), new Date(payment?.holdItemExpiredAt))
  )
}
